var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25858 0.786678C8.25858 0.702502 8.23169 0.628848 8.17791 0.565717C8.07035 0.439453 7.90004 0.439453 7.80144 0.565717L4.60148 4.32206L1.37462 0.534151C1.26706 0.407887 1.09675 0.407887 0.998152 0.534151C0.89059 0.660414 0.89059 0.860331 0.998152 0.976073L4.60148 5.2059L8.17791 1.01816C8.23169 0.955029 8.25858 0.870853 8.25858 0.786678Z",
    fill: "#F22B5D",
    stroke: "#F22B5D",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.8211c2235fafa81d7ff51373e93d051c.svg";
export { ForwardRef as ReactComponent };